export interface FormFieldBase {
  id?: string;
  weight?: number;
  value?: any;
  key?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  controlType?: string;
  placeholder?: string;
  visible?: boolean;
  type?: string;
  size?: string;
  chips?: boolean,
  pattern?: string,
  options?: FormFieldOption[];
  errors?: { [key: string]:string };
  tooltip?: string;
  noEmptyOption?: boolean;
}

export enum FormFieldType {
  RADIO,
  RADIOMONO,
  CHECKBOX,
  TEXT,
  TEXTBOX,
  CHIPS,
  MULTI,
  CURRENCY,
  DROPDOWN,
  SEARCHABLE_DROPDOWN,
  DATE,
  SWITCH,
  NUMBER
}

export interface FormFieldOption {
  key?: string,
  value?: string,
  label?: string ,
  descrizione?: string,
  id?: string,
  rimosso?: boolean,
}


export interface MultiSelectChangePayload {
  control: string;
  listOfSelections: Array<{id?: string, label?: string, descrizione?:string, rimosso?: boolean}>;
}

export interface SelectChangePayload {
  control: string;
  optionSelected: {id?: string, label?: string, descrizione?:string, rimosso?: boolean};
}
